<template>
    <van-row class="row-box">
        <van-col span="24">
            <div class="user-info-box">
                <div>{{ userInfo.name || "-" }}</div>
                <div>{{ userInfo.sex | sexFilter }}</div>
                <div>{{ userInfo.age ? userInfo.age + '岁' : '-' }}</div>
                <div>{{ userInfo.city || "-" }}</div>
            </div>
        </van-col>
        <van-col span="12">
            <div class="lable-box">
                <div class="lable-title">患者编号</div>
                <div class="lable-item" style="align-items: center;">{{ userInfo.id || "-" }}</div>
            </div>
        </van-col>
        <van-col span="12">
            <div class="lable-box">
                <div class="lable-title">手机号</div>
                <div class="lable-item" style="align-items: center;">{{ userInfo.mobile || "-" }}</div>
            </div>
        </van-col>
        <van-col span="24">
            <div class="lable-box">
                <div class="lable-title">健康档案</div>
                <div class="lable-item">
                    <div v-if="userInfo.userMemberHealth" class="cells">
                        <span
                            v-for="(itm, idx) in [[userInfo.userMemberHealth.maritalStatus, userInfo.userMemberHealth.maternityStatus].join('，')].concat(['operation', 'familyHistory', 'drugAllergy', 'foodAllergy', 'diseaseHistory', 'menstrualHistory', 'auxiliaryExamination'].map((key) => userInfo.userMemberHealth[key]).filter((val) => !!val && val != '暂无'))"
                            :key="idx" class="cell">
                            <span>{{ (idx > 0 ? '&nbsp;' : '') + itm }}</span>
                        </span>
                    </div>
                    <div v-else class="cells">
                        <span>无</span>
                    </div>
                </div>
            </div>
        </van-col>
        <van-col span="24">
            <div class="lable-box" style="padding-bottom:0">
                <div class="lable-title">其他标签</div>
                <div class="lable-item">
                    <BaseAddTag :type="1" :tagList="userInfo.tagList" />
                    <div class="tag-operate" @click="goToEdit">
                        <div class="icon-title">修改</div>
                        <div class="icon-box"></div>
                    </div>
                </div>
            </div>
        </van-col>
    </van-row>
</template>
<script>
import BaseAddTag from './baseAddTag.vue';
export default {
    name: "TopHeader",
    props: {
        userInfo: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {};
    },
    methods: {
        goToEdit() {
            this.$router.push({
                name: 'EditMoreEffective',
                query: {
                    type: 1,
                    id: this.$route.query.id
                }
            })
        }
    },
    components: {
        BaseAddTag
    },
};
</script>
<style scoped lang="scss">
.row-box {
    margin-top: 8px;

    .lable-box {
        display: flex;
        padding: 8px 0;

        .lable-title {
            width: 60px;
            font-size: 14px;
            color: #666666;
            text-align: right;
            padding-right: 15px;
        }

        .lable-item {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            flex: 1;
            overflow: hidden;
            display: flex;
            align-items: flex-start;

            .cells {
                color: #333333;
                font-weight: bold;

                .cell {
                    &:nth-child(2n + 1) {
                        color: #3f9053;
                    }
                }
            }
        }
    }

    .user-info-box {
        display: flex;
        flex-wrap: wrap;

        div {
            font-size: 14px;
            color: #333333;
            margin-left: 20px;
            align-self: flex-end;

            &:first-child {
                font-size: 17px;
                font-weight: bold;
                margin-left: 0;
                padding-right: 4px;
            }
        }
    }
}
</style>